import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { SeoTags } from "../../../components/Head/SeoTags";
import { SpacesMock } from "../../../components/Mockups/SpacesMock";

const Spaces = () => {
  const { t } = useTranslation();

  return (
    <>
      <SeoTags
        title={t("featurePages.spaces.seo.title")}
        description={t("featurePages.spaces.seo.description")}
        keywords={t("featurePages.spaces.seo.keywords")}
      />

      <section className="hero bg-purple-subtle">
        <div className="container">
          <div className="row align-items-center min-vh-50">
            <div className="col-lg-6">
              <div className="d-flex flex-column gap-4">
                <div>
                  <span className="badge bg-purple text-white px-3 py-2">
                    {t("home.spaces.badge")}
                  </span>
                </div>
                <h1 className="display-4 fw-bold">
                  {t("featurePages.spaces.hero.title")}
                </h1>
                <p className="lead">
                  {t("featurePages.spaces.hero.description")}
                </p>
                <div>
                  <Link
                    to={`${process.env.REACT_APP_APP_URL}/register`}
                    className="btn btn-primary btn-lg px-4"
                  >
                    {t("featurePages.spaces.hero.cta")}
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <SpacesMock />
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto text-center mb-5">
              <h2 className="h1 fw-bold mb-4">
                {t("featurePages.spaces.problem.title")}
              </h2>
              <p className="lead text-muted">
                {t("featurePages.spaces.problem.description")}
              </p>
            </div>
          </div>

          <div className="row g-4 mb-5">
            <div className="col-md-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-4">
                  <i className="bi bi-tornado fs-2 text-danger mb-3"></i>
                  <h3 className="h5 mb-3">
                    {t("featurePages.spaces.problem.mixing.title")}
                  </h3>
                  <p className="text-muted mb-0">
                    {t("featurePages.spaces.problem.mixing.description")}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-4">
                  <i className="bi bi-person-dash fs-2 text-danger mb-3"></i>
                  <h3 className="h5 mb-3">
                    {t("featurePages.spaces.problem.switching.title")}
                  </h3>
                  <p className="text-muted mb-0">
                    {t("featurePages.spaces.problem.switching.description")}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-4">
                  <i className="bi bi-people fs-2 text-danger mb-3"></i>
                  <h3 className="h5 mb-3">
                    {t("featurePages.spaces.problem.collaboration.title")}
                  </h3>
                  <p className="text-muted mb-0">
                    {t("featurePages.spaces.problem.collaboration.description")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 bg-light">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6 mb-4 mb-lg-0">
              <div className="mb-3">
                <span className="badge bg-purple text-white px-3 py-2">
                  {t("featurePages.spaces.solution.badge")}
                </span>
              </div>
              <SpacesMock />
            </div>
            <div className="col-lg-6">
              <h2 className="h1 fw-bold mb-4">
                {t("featurePages.spaces.solution.title")}
              </h2>
              <p className="lead mb-4">
                {t("featurePages.spaces.solution.description")}
              </p>
              <ul className="list-unstyled">
                <li className="d-flex align-items-start mb-3">
                  <i className="bi bi-check-circle-fill text-success fs-5 me-3 mt-1"></i>
                  <div>
                    <h4 className="h6 mb-1">
                      {t("featurePages.spaces.solution.benefit1.title")}
                    </h4>
                    <p className="text-muted mb-0">
                      {t("featurePages.spaces.solution.benefit1.description")}
                    </p>
                  </div>
                </li>
                <li className="d-flex align-items-start mb-3">
                  <i className="bi bi-check-circle-fill text-success fs-5 me-3 mt-1"></i>
                  <div>
                    <h4 className="h6 mb-1">
                      {t("featurePages.spaces.solution.benefit2.title")}
                    </h4>
                    <p className="text-muted mb-0">
                      {t("featurePages.spaces.solution.benefit2.description")}
                    </p>
                  </div>
                </li>
                <li className="d-flex align-items-start mb-3">
                  <i className="bi bi-check-circle-fill text-success fs-5 me-3 mt-1"></i>
                  <div>
                    <h4 className="h6 mb-1">
                      {t("featurePages.spaces.solution.benefit3.title")}
                    </h4>
                    <p className="text-muted mb-0">
                      {t("featurePages.spaces.solution.benefit3.description")}
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="h1 fw-bold mb-4">
              {t("featurePages.spaces.howItWorks.title")}
            </h2>
            <p className="lead text-muted">
              {t("featurePages.spaces.howItWorks.description")}
            </p>
          </div>

          <div className="row g-4">
            <div className="col-md-4">
              <div className="text-center">
                <div className="rounded-circle bg-purple-subtle d-inline-flex align-items-center justify-content-center mb-3 step-circle">
                  <span className="fs-2 fw-bold text-purple">1</span>
                </div>
                <h3 className="h5 mb-3">
                  {t("featurePages.spaces.howItWorks.step1.title")}
                </h3>
                <p className="text-muted">
                  {t("featurePages.spaces.howItWorks.step1.description")}
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="text-center">
                <div className="rounded-circle bg-purple-subtle d-inline-flex align-items-center justify-content-center mb-3 step-circle">
                  <span className="fs-2 fw-bold text-purple">2</span>
                </div>
                <h3 className="h5 mb-3">
                  {t("featurePages.spaces.howItWorks.step2.title")}
                </h3>
                <p className="text-muted">
                  {t("featurePages.spaces.howItWorks.step2.description")}
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="text-center">
                <div className="rounded-circle bg-purple-subtle d-inline-flex align-items-center justify-content-center mb-3 step-circle">
                  <span className="fs-2 fw-bold text-purple">3</span>
                </div>
                <h3 className="h5 mb-3">
                  {t("featurePages.spaces.howItWorks.step3.title")}
                </h3>
                <p className="text-muted">
                  {t("featurePages.spaces.howItWorks.step3.description")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 bg-light">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 mx-auto text-center">
              <h2 className="h1 fw-bold mb-4">
                {t("featurePages.spaces.useCases.title")}
              </h2>
              <p className="lead text-muted mb-5">
                {t("featurePages.spaces.useCases.description")}
              </p>
            </div>
          </div>

          <div className="row g-4">
            <div className="col-lg-6">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <i className="bi bi-building fs-3 text-purple me-3"></i>
                    <h3 className="h5 mb-0">
                      {t("featurePages.spaces.useCases.professional.title")}
                    </h3>
                  </div>
                  <p className="text-muted mb-3">
                    {t("featurePages.spaces.useCases.professional.description")}
                  </p>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2">
                      <i className="bi bi-arrow-right text-purple me-2"></i>
                      {t("featurePages.spaces.useCases.professional.example1")}
                    </li>
                    <li className="mb-2">
                      <i className="bi bi-arrow-right text-purple me-2"></i>
                      {t("featurePages.spaces.useCases.professional.example2")}
                    </li>
                    <li>
                      <i className="bi bi-arrow-right text-purple me-2"></i>
                      {t("featurePages.spaces.useCases.professional.example3")}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="card h-100 border-0 shadow-sm">
                <div className="card-body p-4">
                  <div className="d-flex align-items-center mb-3">
                    <i className="bi bi-people-fill fs-3 text-purple me-3"></i>
                    <h3 className="h5 mb-0">
                      {t("featurePages.spaces.useCases.team.title")}
                    </h3>
                  </div>
                  <p className="text-muted mb-3">
                    {t("featurePages.spaces.useCases.team.description")}
                  </p>
                  <ul className="list-unstyled mb-0">
                    <li className="mb-2">
                      <i className="bi bi-arrow-right text-purple me-2"></i>
                      {t("featurePages.spaces.useCases.team.example1")}
                    </li>
                    <li className="mb-2">
                      <i className="bi bi-arrow-right text-purple me-2"></i>
                      {t("featurePages.spaces.useCases.team.example2")}
                    </li>
                    <li>
                      <i className="bi bi-arrow-right text-purple me-2"></i>
                      {t("featurePages.spaces.useCases.team.example3")}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="bg-purple rounded-4 p-5 text-center text-white">
            <h2 className="h1 fw-bold mb-4">
              {t("featurePages.spaces.cta.title")}
            </h2>
            <p className="lead mb-4">
              {t("featurePages.spaces.cta.description")}
            </p>
            <Link
              to={`${process.env.REACT_APP_APP_URL}/register`}
              className="btn btn-light btn-lg px-5"
            >
              {t("featurePages.spaces.cta.button")}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default Spaces;